import styled, { css } from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  button {
    margin: 0;
    padding: 0;
    min-width: 40px;
    height: 40px;
    padding: 10px 50px;
    border: 0;
    box-shadow: 0;

    color: #fff;

    background-color: ${props => props.theme.button.primary.in};

    border-left: 1px solid ${props =>
      shade(0.4, props.theme.button.primary.in)};

    ${props =>
      props.size === 'sm' &&
      css`
        padding: 4px 16px;
        height: 25px;
        font-weight: 600;
        font-size: 12px;
      `}

    &:nth-child(${props => props.activeButton}){
      background-color: ${props => shade(0.4, props.theme.button.primary.in)}
    }

    transition: background-color 0.2s;
    &:hover {
      background-color: ${props => shade(0.2, props.theme.button.primary.in)}
      box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
      color: #fff;
    }

    &:first-of-type {
      border-radius: 0.4285rem 0 0 0.4285rem;
      border-left: none;
    }

    &:last-of-type {
      border-radius: 0 0.4285rem 0.4285rem 0;
    }
  }
`;
